import React from 'react';
import CommandPalette from 'react-cmdk';
import styled from 'styled-components';
import { Item } from './item';
import { CommandGroup } from './types';
import { useGetCmdkItemsFromPromise } from './use-get-items';

const StyledList = styled(CommandPalette.List)`
  margin-bottom: var(--spacing-05);
`;

export const GroupToList: React.FC<{
  group: CommandGroup;
  filterText: string;
  renderHeader?: boolean;
}> = ({ filterText, group }) => {
  const items = useGetCmdkItemsFromPromise(group.getCommandItems, filterText);

  return (
    <StyledList heading={items.length > 0 ? group.label : ''}>
      {items.map((e, index) => (
        <Item commandItem={e} index={index} />
      ))}
    </StyledList>
  );
};
